<style lang="scss">


</style>

<template>
  <div class="focused-panel">
    <div class="d-flex centreline-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create Capture Line"
             :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select Line"
             :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Multi Select"
             :pressed.sync="multiEdit" variant="primary">
        <icon scale=".6" name="dice-two"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges"
             @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry"
             :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes"
             :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto
             title="Delete Capture Point" :disabled="!wellFeatureSelected" variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto
             title="Load dependant layers" variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>
    </div>

    <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-close-on-esc id='capture-point-editor-modal'>
      <div slot="modal-header">
        <label>{{ formTitle }}</label>

      </div>

      <div class="p-2 pl-4">
        <b-form>
          <b-row>

            <b-col>
              <b-form-group label="Point Type:" label-for="etype">
                <b-form-select :options="etypes" id="etype" v-model="wellAttrs['etype']"
                               placeholder="Please, select point type"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <b-col>
              <b-form-group label="Comment:" label-for="description">
                <b-textarea id="description" v-model="wellAttrs['description']" rows="3"></b-textarea>
              </b-form-group>
            </b-col>

          </b-row>

        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer w-100">
        <div role="group" class="btn-group">
          <b-btn size="sm" variant="primary" @click="close" style="min-width:80px">
            Close
          </b-btn>
          <b-btn size="sm" variant="success"
                 @click="onOK" style="min-width:80px">
            Save
          </b-btn>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import 'vue-awesome/icons/list-ol'
import 'vue-awesome/icons/cut'
import 'vue-awesome/icons/compress'
import 'vue-awesome/icons/hand-pointer'
import 'vue-awesome/icons/undo'
import 'vue-awesome/icons/exchange-alt'
import 'vue-awesome/icons/bezier-curve'
import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/backward'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/unlock'
import 'vue-awesome/icons/dice-two'
import Feature from 'ol/Feature'
import uuidV1 from 'uuid/v1'
import Vue from 'vue'
import {parallel} from 'async'

export default {
  name: 'field-capture-polyline-editor',

  components: {},
  mixins: [FeatureEditorMixin],
  data() {
    return {
      idName: 'objectid',
      etypes: [
        'Line: Any Boundary used for trimming',
        'Line: Awning /eaves on buildings',
        'Line: Bank - bottom',
        'Line: Big sign',
        'Line: Boundary of Native title or claim',
        'Line: Bridge abutment /pier /footing',
        'Line: Bridge abutment /Pier headstock bottom',
        'Line: Bridge Bearing',
        'Line: Bridge Column/Pier outline',
        'Line: Bridge Deck',
        'Line: Bridge Deck Soffit',
        'Line: Bridge Expansion Joint',
        'Line: Bridge kerb /Parapet top - Noncontourable ORG-ARW-GIS-STA-00013',
        'Line: Bridge traffic rail post centre',
        'Line: Cadastral Lot on Plan text',
        'Line: Centre of trunk of large tree (use with code TR)',
        'Line: Change of grade',
        'Line: Chevron marking outline',
        'Line: Continuity line /Give Way bar',
        'Line: County boundary',
        'Line: Culvert headwall - Top',
        'Line: DBYD Electricity - Power line poles indicated',
        'Line: DBYD Electricity - Power lines no poles',
        'Line: DBYD Electricity - Underground',
        'Line: DBYD Fuel Line - Aboveground',
        'Line: DBYD Fuel Line - Underground',
        'Line: DBYD Gas Line - Underground',
        'Line: DBYD Oil Line - Underground',
        'Line: DBYD Optic Fibre - Aboveground',
        'Line: DBYD Optic Fibre - Aboveground poles indcated',
        'Line: DBYD Optic Fibre - Underground ORG-ARW-GIS-STA-00013',
        'Line: DBYD Sewer Main - Underground',
        'Line: DBYD Sewer Rising Main - Underground',
        'Line: DBYD Telecommunications - Aboveground no poles',
        'Line: DBYD Telecommunications - Aboveground poles indicated',
        'Line: DBYD Telecommunications - Underground',
        'Line: DBYD Unspecified - Aboveground',
        'Line: DBYD Unspecified - Underground',
        'Line: DBYD Watermain - Underground',
        'Line: DCDB boundary',
        'Line: DCDB Easement boundary',
        'Line: DCDB Lot on Plan text',
        'Line: Doorway (streched)',
        'Line: Drain - Down',
        'Line: Drain - Drainage line',
        'Line: Drain - Up',
        'Line: Dwelling - Left',
        'Line: Dwelling - Right',
        'Line: Easement boundary',
        'Line: Edge of Cultivation left',
        'Line: Edge of Cultivation right',
        'Line: Edge of Driveway',
        'Line: Edge of Footpath',
        'Line: Edge of pavement',
        'Line: Edge of Rock outcrop',
        'Line: Edge of shoulder ORG-ARW-GIS-STA-00013',
        'Line: Edge of track',
        'Line: Edge of Tree foliage',
        'Line: Edge of Vegetation left',
        'Line: Edge of Vegetation right',
        'Line: Edge of water',
        'Line: Environment - Rock/Gravel - loose',
        'Line: Environment - Wetland plants - area',
        'Line: Fence - chainwire',
        'Line: Fence - Weldmesh',
        'Line: Fence line - posts located',
        'Line: Fence line no posts - wires only',
        'Line: Flood debris',
        'Line: Flood Mark',
        'Line: Floor level of building',
        'Line: Fuel line',
        'Line: Fuel line - underground',
        'Line: General survey mark',
        'Line: Geotechnical investigation bore',
        'Line: Geotechnical investigation marker',
        'Line: Geotechnical investigation test pit',
        'Line: Isolated fence post',
        'Line: Isolated power pole',
        'Line: Kerb - back',
        'Line: Kerb - Channel lip',
        'Line: Kerb - Invert of channel',
        'Line: Limit of swamp',
        'Line: linemarking - broken on left',
        'Line: linemarking - broken on right',
        'Line: linemarking - double unbroken',
        'Line: linemarking - hold line',
        'Line: linemarking - Separation 6x6',
        'Line: linemarking - Separation 9x3',
        'Line: linemarking - Stop bar',
        'Line: linemarking - turning',
        'Line: linemarking - unbroken',
        'Line: Manhole - Electricity',
        'Line: Marker post - Electricity',
        'Line: Marker Post - Telecommunications',
        'Line: Non-standard feature point',
        'Line: Optical fibre - above ground (no poles)',
        'Line: Optical fibre - above ground (poles located)',
        'Line: Parish boundary',
        'Line: Parking meter',
        'Line: Pastoral boundary',
        'Line: Pedestrian crossing (two points)',
        'Line: Photogrammetric breakline',
        'Line: Plot culvert',
        'Line: Post box ORG-ARW-GIS-STA-00013',
        'Line: Property boundary',
        'Line: Retaining wall - bottom',
        'Line: Retaining wall - Left top',
        'Line: Retaining wall - Right top',
        'Line: Road crown',
        'Line: Sewer main',
        'Line: Shire boundary',
        'Line: Spot height',
        'Line: State boundary',
        'Line: Stay pole / Bollard (two points)',
        'Line: Stay wire (two points)',
        'Line: Stream bank - left',
        'Line: Stream bank - right',
        'Line: Stream gradient - with the flow',
        'Line: Streams gradient - against the flow',
        'Line: Street /Advertising sign',
        'Line: Street /Advertising sign - illuminated',
        'Line: Street light',
        'Line: Subsoil drain - against the flow',
        'Line: Subsoil drain - with the flow',
        'Line: Tank',
        'Line: Telecommunication above ground (poles located)',
        'Line: Telecommunications above ground (no poles)',
        'Line: Telephone Box',
        'Line: Top of bank - Left',
        'Line: Top of bank - Right',
        'Line: Traffic light with Mast arm (two points)',
        'Line: Traffic sign - double sided',
        'Line: Tramway line - Top of rail',
        'Line: Tramway track - centreline',
        'Line: Transformer on pole',
        'Line: Tranverse stressing bar',
        'Line: Traverse line',
        'Line: Underground gas line',
        'Line: Unspecified feature - Above ground',
        'Line: Unspecified feature - Underground',
        'Line: Water main',
        'Line: Water meter',
        'Line: Wind fence',
        'Line: Windmill'
      ],
      wellAttrs: {
        etype: null,
        description: ''
      },
      geomType: 'LineString',
      wellLayerName: 'fr:field_capture_polyline',
      multiEdit: false,
    }
  },
  created() {
    this.selectTool = null
  },

  methods: {
    validateIdent() {
      this.identState = true
    },
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    }
  },
  watch: {},
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/FieldCapturePolylineEditor.vue